import { render } from "./PortfolioHub.vue?vue&type=template&id=53cad322&scoped=true"
import script from "./PortfolioHub.vue?vue&type=script&lang=js"
export * from "./PortfolioHub.vue?vue&type=script&lang=js"

import "./PortfolioHub.vue?vue&type=style&index=0&id=53cad322&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cad322"]])

export default __exports__